function Error404(){
  return(
    <>
    404 Not found
    </>
  )
}
export default Error404;